export enum EnumTypeDocument {
    CHEQUE = "CHEQUE",
    DUPLICATA = "DUPLICATA",
    NOTA_PROMISSORIA = "NOTA_PROMISSORIA",
}
